/**
 * Defines travel info message criticality options.
 */
export enum Criticality {
  /**
   * Defines a non critical issue.
   */
  Normal = 'Normal',

  /**
   * Defines an important issue.
   */
  Important = 'Important',

  /**
   * Defines a critical issue.
   */
  Critical = 'Critical',
}
